import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions, event, asyncGetQrcode } from '../../model';
import styles from './chipEdit.css';
import Dialog from './Dialog/';
import SiderTools from './SiderTools/';
import isDevMode from '../../utils/isDevMode';
import copyId from '../../utils/copyId';
import createPostUrl from '../../utils/createPostUrl';
import createPreviewUrl from '../../utils/createPreviewUrl';
import recommendFilter from '@ifeng-fe/recommend_filter';

import allChipsUpdate from '../../utils/updateAllChips';

// 如果可视化页面的协议是http的，则改为https重新加载，用于修复可视化页面的碎片窗口无法登录的问题
// 可视化窗口的地址为https，由于chrome的安全限制，如果父窗口为http的话，登录后cookie无法写入，会导致登录失败，故做此修复
try {
    if (typeof window !== 'undefined' && window.allData && window.allData.__env__ === 'production') {
        if (window.location.protocol === 'http:') {
            window.location.href = `https://${window.location.host}${window.location.pathname}${
                window.location.search
            }${window.location.hash}`;
        }
    }
} catch (error) {
    console.log(error);
}

const ctx = {
    host: window.location.host,
    devicetype: window.location.href.includes('visualediting/mobile') ? 'mobile' : 'pc',
};

const params = data => {
    const result = [];

    for (const key of Object.keys(data)) {
        result.push(`${key}=${data[key]}`);
    }

    return result.join('&');
};
const postFecth = async (url, data) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params(data),
    });

    return await response.json();
};

const transformRecommendData = async data => {
    try {
        const response = await fetch(`https://ucms.ifeng.com/platform/services/api/recommend/filter/${Date.now()}`, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data }),
        });

        return response.json();
    } catch (error) {
        return { code: 0, data };
    }
};

// 临时修复切换新推荐位后，预览图片还是读取thumbnail的问题，将thumbnails的第一张图片赋值给thumbnail。

const polyfillRecommend = function polyfillRecommend(data) {
    if (Array.isArray(data)) {
        return data.map(item => {
            if (
                !item.thumbnail &&
                typeof item.thumbnails === 'object' &&
                Array.isArray(item.thumbnails.image) &&
                item.thumbnails.image.length > 0
            ) {
                item.thumbnail = item.thumbnails.image[0].url;
            }

            return item;
        });
    } else {
        return data;
    }
};

class ChipEdit extends React.PureComponent {
    static propTypes = {
        uiStateUpdate: PropTypes.func,
        currentChipIndexUpdate: PropTypes.func,
        dialogUpdate: PropTypes.func,
        chips: PropTypes.array,
        uiState: PropTypes.object,
        dialogData: PropTypes.object,
        chipsHideState: PropTypes.object,
        asyncGetQrcode: PropTypes.func,
    };

    async transformData(id, type, data, translate, translateOptions) {
        const { transform } = this.props;

        if (translateOptions) {
            return transform[translate](translateOptions)(data);
        } else {
            return transform[translate](data);
        }
    }

    receiveMessage = async e => {
        const { chips, currentChipIndex } = this.props;
        let { name, action, data, id, type } = e.data;

        if (name === 'chipedit') {
            try {
                let translate = '';
                let translateOptions = null;
                const currentChip = chips.filter(
                    item =>
                        item.id.toString() === id.toString() && item.type === type && item.index === currentChipIndex,
                )[0];

                if (currentChip) {
                    translate = currentChip.translate;
                    translateOptions = currentChip.translateOptions;
                }
                let transformData = data;

                if (type === 'recommend') {
                    data = polyfillRecommend(data);
                    const result = await transformRecommendData(data);

                    if (result.code === 0) {
                        transformData = result.data;
                    }
                }

                if ((action === 'save' || action === 'preview') && translate) {
                    transformData = await this.transformData(
                        id,
                        type,
                        recommendFilter(ctx, data, 'ui'),
                        translate,
                        translateOptions,
                    );
                }
                event.trigger(`chip_${type}_${id}_${currentChipIndex}_update`, { data: transformData, action });
                switch (action) {
                    case 'preview':
                        this.props.uiStateUpdate({
                            isPreview: true,
                        });
                        this.updatePreviewData(id, type, data);
                        break;
                    case 'close':
                        this.props.uiStateUpdate({
                            dialogIsShow: false,
                        });
                        break;
                    case 'fullPreview':
                        await this.updatePreviewData(id, type, data);
                        window.open(createPreviewUrl(this.previewId), 'preview', '');
                        break;
                    case 'save':
                        this.updatePreviewData();
                        if (window.location.href.includes('visualediting/mobile')) {
                            window.location.href = `${
                                window.location.href.split('visualediting')[0]
                            }visualediting/mobile/${this.previewId}__time__${Date.now()}${window.location.search}`;
                        } else {
                            window.location.href = `${window.location.href.split('visualediting')[0]}visualediting/${
                                this.previewId
                            }__time__${Date.now()}${window.location.search}`;
                        }
                        break;
                    case 'cancle':
                        this.updatePreviewData();
                        break;
                    default:
                        break;
                }
            } catch (e) {
                console.error('数据转换失败', id, type, data);
                console.error(e);
            }
        }
    };
    resize = () => {
        // console.log('resize:', this.props.uiState.isPreviewAll);
        if (!this.props.uiState.isPreviewAll) {
            allChipsUpdate();
        }
    };

    previewId = null;

    getPreviewId = async () => {
        const url = createPostUrl();

        if (window.location.href.includes('__time__')) {
            const uid = window.location.href.match(/([0-9a-z-]+)__time__/)[1];

            this.previewId = uid;

            return uid;
        }

        if (this.previewId) {
            return this.previewId;
        }

        try {
            const { data } = await postFecth(url, { action: 'make_uid' });

            this.previewId = data;
            postFecth(url, { action: 'update', uid: data });

            return data;
        } catch (error) {
            console.log(error);
        }
    };

    updatePreviewData = async (id, type, data) => {
        const url = createPostUrl();

        if (id) {
            await postFecth(url, {
                action: 'update',
                uid: this.previewId,
                id: `${id}`,
                type,
                data: encodeURIComponent(JSON.stringify(data)),
            });
        } else {
            await postFecth(url, {
                action: 'update',
                uid: this.previewId,
            });
        }
    };
    async componentDidMount() {
        window.addEventListener('message', this.receiveMessage, false);
        window.addEventListener('resize', this.resize, false);
        const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        // 选择目标节点
        const target = document.querySelector('body');

        // 创建观察者对象
        this.observer = new MutationObserver(mutations => {
            this.resize();
        });
        // 配置观察选项:
        const config = { attributes: true, childList: true, characterData: true, subtree: true };

        // 传入目标节点和观察选项
        this.observer.observe(target, config);
        try {
            const previewId = await this.getPreviewId();
            const url = createPreviewUrl(previewId);

            this.props.asyncGetQrcode(url, 'preview');
            this.props.asyncGetQrcode(window.location.href.split('visualediting')[0], 'online');
            this.props.asyncGetQrcode(`${url}/app`, 'appPreview');
        } catch (error) {
            console.log(error);
        }
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage);
        window.removeEventListener('resize', this.resize);
        this.observer.disconnect();
    }
    divClick(item) {
        this.openDialog(item);
    }

    openDialog = item => {
        const openList = {
            static: 'static',
            recommend: 'recommend',
            struct: 'struct',
        };

        if (item.user === 'dev' && !openList[item.type]) {
            copyId(item);

            return;
        }

        this.props.currentChipIndexUpdate(item.index);
        this.props.uiStateUpdate({ listIsShow: false, dialogIsShow: true, devListIsShow: false });
        this.props.dialogUpdate({
            title: item.title,
            id: item.id,
            type: item.type,
            uid: item.uid,
        });
    };

    render() {
        // console.log('render it');
        const { chips, uiState, dialogData, chipsHideState } = this.props;
        const { isPreview, isPreviewAll } = uiState;
        const { uid } = dialogData;

        return (
            <f-div>
                <Dialog />
                <SiderTools openDialogCallback={this.openDialog} />
                {chips
                    .filter(
                        item =>
                            // 1. 如果在预览状态，并且uid和当前预览的一致
                            // 2. 如果是全页预览（即所有碎片遮罩都要隐藏）
                            // 3. 如果碎片遮罩状态是隐藏
                            // 4. 如果是非开发模式并且当前碎片的用户属性是 editor，或者是开发模式
                            !(isPreview && uid === item.uid) &&
                            !isPreviewAll &&
                            !chipsHideState[item.uid] &&
                            ((!isDevMode() && item.user === 'editor') || isDevMode()),
                    )
                    .map(item => {
                        return item.position === 'absolute' ? (
                            <f-div
                                key={item.uid}
                                class={item.user === 'dev' ? styles.boxDev : styles.box}
                                style={{
                                    width: item.rect.width,
                                    height: item.rect.height,
                                    top: item.rect.top,
                                    left: item.rect.left,
                                }}
                                onClick={() => this.divClick(item)}>
                                <f-div class={item.user === 'dev' ? styles.titleDev : styles.title}>
                                    {item.title || item.key}
                                </f-div>
                            </f-div>
                        ) : (
                            ReactDOM.createPortal(
                                <f-div
                                    key={item.uid}
                                    class={item.user === 'dev' ? styles.boxDevIn : styles.boxIn}
                                    onClick={() => this.divClick(item)}>
                                    <f-div class={item.user === 'dev' ? styles.titleDev : styles.title}>
                                        {item.title || item.key}
                                    </f-div>
                                </f-div>,
                                document.querySelector(`[data-__chip-target="${item.uid}"]`),
                            )
                        );
                    })}
            </f-div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    transform: props.transform,
    chips: state.chips,
    dialogData: state.dialogData,
    uiState: state.uiState,
    chipsHideState: state.chipsHideState,
    currentChipIndex: state.currentChipIndex,
});

const mapDispatchToProps = dispatch => ({
    dialogUpdate: data => dispatch(actions.dialogUpdate(data)),
    uiStateUpdate: data => dispatch(actions.uiStateUpdate(data)),
    currentChipIndexUpdate: id => dispatch(actions.currentChipIndexUpdate(id)),
    asyncGetQrcode: (url, type) => dispatch(asyncGetQrcode(url, type)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ChipEdit);
